import React, { useState } from 'react';

// 制作步骤数据
const tutorialSteps = [
  {
    id: 1,
    title: '测量尺寸',
    description: '使用软尺测量手腕周长，确保手链佩戴舒适',
    image: 'https://via.placeholder.com/400x300/FFB3BA/ffffff?text=测量尺寸',
    details: [
      '将软尺围绕手腕最宽处测量',
      '留出1-2厘米的余量，确保手链不会太紧',
      '记录测量结果，用于后续计算所需珠子数量'
    ]
  },
  {
    id: 2,
    title: '选择材料',
    description: '根据设计方案选择合适的珠子、线材和配件',
    image: 'https://via.placeholder.com/400x300/BAFFC9/ffffff?text=选择材料',
    details: [
      '选择与设计风格匹配的珠子',
      '根据珠子大小和重量选择合适的线材',
      '准备好扣子、弹簧等配件'
    ]
  },
  {
    id: 3,
    title: '穿线',
    description: '将珠子按照设计方案穿在线材上',
    image: 'https://via.placeholder.com/400x300/BAE1FF/ffffff?text=穿线',
    details: [
      '将线材穿过珠子中心的孔洞',
      '按照设计顺序排列珠子',
      '注意保持珠子排列整齐，避免线材打结'
    ]
  },
  {
    id: 4,
    title: '收尾',
    description: '将线材两端固定，安装扣子和配件',
    image: 'https://via.placeholder.com/400x300/FFFFBA/ffffff?text=收尾',
    details: [
      '将线材两端穿过扣子',
      '使用结扣固定线材',
      '修剪多余的线材',
      '确保扣子和配件安装牢固'
    ]
  },
  {
    id: 5,
    title: '检查',
    description: '检查手链的质量和外观',
    image: 'https://via.placeholder.com/400x300/E2BAFF/ffffff?text=检查',
    details: [
      '检查珠子排列是否整齐',
      '检查扣子和配件是否安装牢固',
      '试戴手链，确保佩戴舒适',
      '进行最后的调整和修饰'
    ]
  }
];

const TutorialSteps = () => {
  const [expandedStep, setExpandedStep] = useState(null);

  // 切换步骤展开/收起
  const toggleStep = (stepId) => {
    setExpandedStep(expandedStep === stepId ? null : stepId);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 to-orange-50 py-8">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl font-bold text-center mb-8 text-pink-800">
          手链制作步骤图文教程
        </h1>
        
        {/* 步骤列表 */}
        <div className="space-y-6">
          {tutorialSteps.map((step) => (
            <div key={step.id} className="bg-white rounded-xl shadow-lg border border-pink-100 overflow-hidden">
              {/* 步骤标题和图片 */}
              <div 
                className="p-6 cursor-pointer flex flex-col md:flex-row items-center justify-between" 
                onClick={() => toggleStep(step.id)}
              >
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full bg-pink-100 flex items-center justify-center text-pink-800 font-bold text-xl">
                    {step.id}
                  </div>
                  <h2 className="text-xl font-semibold text-pink-700">
                    {step.title}
                  </h2>
                </div>
                <div className={`transform transition-transform duration-300 ${
                  expandedStep === step.id ? 'rotate-180' : ''
                }`}>
                  ▼
                </div>
              </div>
              
              {/* 展开内容 */}
              {expandedStep === step.id && (
                <div className="px-6 pb-6">
                  <div className="mb-4">
                    <img
                      src={step.image}
                      alt={step.title}
                      className="w-full h-64 object-cover rounded-lg shadow-md"
                    />
                  </div>
                  <p className="text-gray-600 mb-4">{step.description}</p>
                  <h3 className="font-semibold text-pink-700 mb-2">详细步骤：</h3>
                  <ul className="list-disc pl-6 text-gray-600 space-y-1">
                    {step.details.map((detail, index) => (
                      <li key={index}>{detail}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TutorialSteps;